import { FC, use } from 'react';
import { ICmsSection } from '../../(cms)/CMSComponents/services/types';
import DigitalCard from './DigitalCard';
import { IDigitalCard } from '@/src/types/digitalCards';
import Container from '@/src/components/ui/container';
import { ThemeLayout } from '../../(cms)/CMSComponents/Components/ThemeLayout';
import { SliderLayout } from '@/src/components/Layout/SliderLayout';
import Typography from '@/src/components/ui/typography';
import { Badge } from '@/src/components/ui/Badge';
import { Link } from '@/src/i18n/navigation';
import { ChevronRight } from 'lucide-react';
import ExpressIcon from '@/src/components/icons/ExpressIcon';
import { useTranslations } from 'next-intl';
import { Routes } from '@/src/routes/routes';
import { getSession, useSession } from 'next-auth/react';

type Props = {
  data: ICmsSection;
};

const DigitalCardHeader = ({ name, description }: { name: string; description: string }) => {
  const t = useTranslations('digitalCards');
  return (
    <div className="mb-6 flex items-center justify-between">
      {/* title and icone */}
      <div className="flex flex-col items-start gap-2">
        <Typography variant="h4" component={'h2'} weight={'semibold'} className="text-inherit">
          {name}
        </Typography>

        <Badge variant="primary" className="rounded-full px-2 py-0 text-sm font-medium">
          <ExpressIcon className="me-2 h-4 w-4" /> {t('instantDigitalCard')}
        </Badge>
      </div>

      <Link
        href={Routes.digitalCards}
        className="text-primary flex items-center rounded-full bg-white px-3 py-2 text-base font-medium shadow"
      >
        {t('viewMore')} <ChevronRight className="ms-2 h-5 w-5 rtl:rotate-180" />
      </Link>
    </div>
  );
};

const DigitalCardLink: FC<Props> = ({ data }) => {
  const didgtialCardContent = (
    typeof data.content === 'string' ? JSON.parse(data.content) : data.content
  ) as IDigitalCard[];

  const session = useSession();

  return (
    <Container>
      <ThemeLayout
        id={data?.id.toString()}
        alt={data.name}
        theme={data?.theme}
        header={<DigitalCardHeader name={data.name} description={data.description} />}
      >
        <SliderLayout
          itemsClassName=" basis-[46%] sm:basis-[35%] md:basis-[24%] lg:basis-[21%] md:pl-4 pl-2"
          conatinerClassName="lg:ps-6 ps-3"
        >
          {didgtialCardContent?.map((item, index) => (
            <div key={index} className="w-full">
              <DigitalCard data={item} token={session?.data?.access_token || ''} />
            </div>
          ))}
        </SliderLayout>
      </ThemeLayout>
    </Container>
  );
};

export default DigitalCardLink;
